import React from 'react'
import PropTypes from 'prop-types'

import { getBuyerProfileByKey } from 'functions/campaign'

class BuyerProfilesWrapper extends React.Component {
  render(){
    const { campaign, render } = this.props

    const campaignData = campaign.data || {}
    const profileKeys = campaignData.buyer_profiles || []

    if (!profileKeys.length) return null

    const buyerProfiles = profileKeys.map(key => getBuyerProfileByKey(key)).filter(profile => profile)

    return render({
      buyerProfiles,
    })
  }
}

BuyerProfilesWrapper.propTypes = {
  campaign: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

export default BuyerProfilesWrapper
